import { AxiosPromise } from 'axios'
import Request from '../Request'

//Формат json данных для бека
export interface IRequest {
  name: string
  company: string
  inn: string
  phone: string
  email: string
  utm_campaign?: string
}

export type TBanner = {
  bg_color: string
  detail_picture: string
  detail_text: string
  id: string
  image_desktop: string
  image_mobile: string
  button_link_to: string
  button_text: string
  image_tablet: string
  title: string
  name: string
  section_description: string
  section_name: string
}
export type TSlider = {
  bg_color: string
  button_text: string
  detail_picture: string
  detail_text: string
  id: string
  image: string
  name: string
  section_description: string
  section_name: string
  title: string
  video_link?: string
  video_type?: boolean
}

export type TBenefit = {
  mark: string
  description: string
  subtitle: string
  icon: string
}

export type TServerData = {
  status: string
  result: {
    landingBanner: TBanner[]
    landingSlider: TSlider[]
    landingBenefits: TBenefit[]
  }
}

export type TComplete = {
  PHRASE: string
}

export type TCompleteData = {
  status: string
  result: {
    [key: string]: TComplete
  }
}

class Form {
  static send(data: IRequest): AxiosPromise {
    return Request.post('landing/mmb/send/', data)
  }
  static get(): AxiosPromise<TServerData> {
    return Request.get('landing/mmb/')
  }

  static getAutocompleteValues(value: string): AxiosPromise<TCompleteData> {
    return Request.get(`search/${value}/`)
  }
}

export default Form
